import ProxyConfig from './ProxyConfig'
import {IErrorReporter} from '../lib/IErrorReporter'

enum ApiProvider {
  RolloutEu = 'eu',
  Platform = 'platform',
}

const API_HOST = 'x-api.rollout.io'
let _proxyConfig = new ProxyConfig()

type IConfiguration = {
  API_HOST?: string
  CD_API_ENDPOINT: string
  CD_S3_ENDPOINT: string
  SS_API_ENDPOINT: string
  SS_S3_ENDPOINT: string
  CLIENT_DATA_CACHE_KEY: string
  NOTIFICATIONS_ENDPOINT: string
  ANALYTICS_ENDPOINT: string
  ERROR_REPORTER: IErrorReporter
}

const DEFAULT_CONFIGURATION = (hostProvider?: string): IConfiguration => {
  let apiHost = API_HOST

  if (hostProvider == ApiProvider.RolloutEu) {
    apiHost = `${'eu-'}${API_HOST}` // as this goes into the url, not using the roxOptions.hosting value. instead using RoxOptions.hosting === "eu" as indication to use "eu-x-api..."
  }

  const configuration = {
    API_HOST: apiHost,
    CD_API_ENDPOINT: `https://${apiHost}/device/get_configuration`,
    CD_S3_ENDPOINT: `https://conf.rollout.io/`,
    SS_API_ENDPOINT: `https://${apiHost}/device/update_state_store/`,
    SS_S3_ENDPOINT: `https://statestore.rollout.io/`,
    CLIENT_DATA_CACHE_KEY: 'client_data',
    NOTIFICATIONS_ENDPOINT: `https://push.rollout.io/sse`,
    ANALYTICS_ENDPOINT: `https://analytic.rollout.io`,
    ERROR_REPORTER: undefined,
  }

  if (hostProvider == ApiProvider.Platform) {
    configuration.API_HOST = 'api.cloudbees.io'
    configuration.CD_API_ENDPOINT = 'https://api.cloudbees.io/device/get_configuration'
    configuration.CD_S3_ENDPOINT = 'https://rox-conf.cloudbees.io/'
    configuration.SS_API_ENDPOINT = 'https://api.cloudbees.io/device/update_state_store/'
    configuration.SS_S3_ENDPOINT = 'https://rox-state.cloudbees.io/'
    configuration.ANALYTICS_ENDPOINT = 'https://fm-analytics.cloudbees.io'
    configuration.NOTIFICATIONS_ENDPOINT =
      'https://sdk-notification-service.cloudbees.io/sse'
  }

  return configuration
}

const SELFMANAGEDMODE_CONFIGURATION = ({
  analyticsURL,
  serverURL,
  pushUpdateURL,
  configurationURL,
  stateURL,
}): IConfiguration => ({
  CD_API_ENDPOINT: `${serverURL}/device/get_configuration`,
  SS_API_ENDPOINT: `${serverURL}/device/update_state_store/`,
  CLIENT_DATA_CACHE_KEY: 'client_data',
  ANALYTICS_ENDPOINT: analyticsURL,
  NOTIFICATIONS_ENDPOINT: `${pushUpdateURL}/sse`,
  CD_S3_ENDPOINT: configurationURL,
  SS_S3_ENDPOINT: stateURL,
  ERROR_REPORTER: undefined,
})

let _activeConfiguration = Object.assign({}, DEFAULT_CONFIGURATION())

export default {
  get: (key) => _activeConfiguration[key],
  set: (key, value) => {
    _activeConfiguration[key] = value
  },
  setActive: function (newConfiguration) {
    _activeConfiguration = Object.assign({}, newConfiguration)
  },
  setProxy: function (proxySettings) {
    _proxyConfig = new ProxyConfig(proxySettings)
  },
  getProxy: () => _proxyConfig,
  setHosting: function (hosting: string) {
    if (hosting === ApiProvider.RolloutEu) {
      _activeConfiguration = Object.assign({}, DEFAULT_CONFIGURATION('eu-'))
    }
    if (hosting === ApiProvider.Platform) {
      _activeConfiguration = Object.assign({}, DEFAULT_CONFIGURATION(hosting))
    }
  },

  setSelfManagedMode: function (conf) {
    _activeConfiguration = Object.assign(
      {},
      DEFAULT_CONFIGURATION(),
      SELFMANAGEDMODE_CONFIGURATION(conf)
    )
  },
  setErrorReporter: function (errorReporter: IErrorReporter | undefined) {
    _activeConfiguration.ERROR_REPORTER = errorReporter
  },
  /**
   * Get the error reporter, or undefined if there is none configured.
   * Don't forget to check for undefined before using!
   */
  getErrorReporter: (): IErrorReporter | undefined => _activeConfiguration.ERROR_REPORTER,
}
